module.exports = __webpack_public_path__ + "img/logo-tours-evenements.2851f08d.png";